import api from "@/services/api";
import ReactPixel from "react-facebook-pixel";

const EVENTS = {
  Consult15min: "15min_konsultacija",
  QuizCompleted: "QuizCompleted",
  AddToCart: "AddToCart",
  ItemAdded: "ItemAdded",
  NewsletterSubscription: "Naujienlaiskio_prenumerata",
  InitiateCheckout: "InitiateCheckout",
  Purchase: "Purchase",
  SleepGuideStarted: "Sleep guide started",
  SleepGuideEnded: "Sleep guide ended",
};

const useMetaPixel = () => {
  const _track = (
    action: "track" | "trackCustom",
    name: string,
    data?: any,
  ) => {
    if (!(window as any)?.fbq) {
      setTimeout(() => {
        ReactPixel.fbq(action, name, data);
      }, 1000);
    } else {
      ReactPixel.fbq(action, name, data);
    }
  };

  const trackBackend = async (
    eventName: string,
    eventUrl: string,
    customData?: any,
  ) => {
    try {
      await api.post("/meta/events", {
        event_name: eventName,
        event_url: eventUrl,
        custom_data: customData,
      });
    } catch (error) {
      console.error(
        `Meta Pixel backend tracking failed for ${eventName}:`,
        error,
      );
    }
  };

  const track15minConsult = (path: string) =>
    _track("trackCustom", `${EVENTS.Consult15min}_${path}`);

  const trackAddToCart = (
    productName: string,
    id: number,
    priceInCents: number,
    eventUrl: string,
  ) => {
    trackBackend(EVENTS.ItemAdded, eventUrl, {
      product_name: productName,
      product_id: id,
      product_price: priceInCents / 100,
    });
  };

  const trackSubscribeToNewsletter = () => {
    _track("trackCustom", EVENTS.NewsletterSubscription);
  };

  const trackQuizCompletion = (name: string) => {
    _track("trackCustom", `${EVENTS.QuizCompleted}_${name}`);
  };

  const trackInitiateCheckout = (eventUrl: string) => {
    trackBackend(EVENTS.InitiateCheckout, eventUrl);
  };

  const trackPurchase = (
    order: {
      id: string;
      total_cents: number;
      discount_percent: number;
    },
    eventUrl: string,
  ) => {
    trackBackend(EVENTS.Purchase, eventUrl, {
      currency: "EUR",
      value: order.total_cents / 100,
      orderId: order.id,
      discount_percent: order.discount_percent,
    });
  };

  const trackSleepGuideStarted = (eventUrl: string) => {
    trackBackend(EVENTS.SleepGuideStarted, eventUrl);
  };

  const trackSleepGuideEnded = (eventUrl: string) => {
    trackBackend(EVENTS.SleepGuideEnded, eventUrl);
  };

  return {
    track15minConsult,
    trackQuizCompletion,
    trackAddToCart,
    trackSubscribeToNewsletter,
    trackInitiateCheckout,
    trackPurchase,
    trackSleepGuideStarted,
    trackSleepGuideEnded,
  };
};

export default useMetaPixel;
